module.exports = __webpack_public_path__ + "img/34.975c84c6.png";